import { useNavigate } from "@tanstack/react-router";
import { TrendsType } from "reedy-data/models";
import { useTranslation } from "react-i18next";
import { InfoIcon } from "lucide-react";
import { Text } from "components/text";
import { SearchTermsSourceSelect } from "../components/SearchTermsSourceSelect";
import { SearchTermsCountryToggle } from "../components/SearchTermsCountryToggle";

export const SearchTermsAmazonPreHeader = ({
  trends,
  countryCodes,
  countryCode,
  onCountryCodeChange,
  week,
}: {
  trends: TrendsType[];
  countryCodes: string[];
  countryCode: string;
  onCountryCodeChange: (countryCode: string) => void;
  week?: string;
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation(["searchTerms"]);

  return (
    <div className="flex flex-row w-full items-center flex-wrap gap-2">
      <div className="flex flex-col items-center flex-start gap-2">
        <SearchTermsSourceSelect
          trends={trends}
          onChange={(trend) => {
            switch (trend) {
              case TrendsType.GOOGLE:
                navigate({ to: "/search-terms" });
                return null;
              default:
                return null;
            }
          }}
          value={TrendsType.AMAZON}
        />
      </div>

      <div className="flex flex-row items-center flex-wrap gap-2 lg:flex-1">
        <SearchTermsCountryToggle
          countryCodes={countryCodes}
          value={countryCode}
          onChange={onCountryCodeChange}
        />
        {week ? (
          <span className="flex flex-row md:ml-auto items-center gap-1 rounded-full bg-secondary-50 px-2 py-0.5">
            <InfoIcon size={16} />
            <Text as="span" variant="caption">
              {t("searchTerms:table.headers.week")} {week}
            </Text>
          </span>
        ) : null}
      </div>
    </div>
  );
};
